import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import Images from 'assets/images/imageData';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import ModalPop from 'components/sales/modal/modal';
import { Link } from 'react-router-dom';
import ErrModalPop from 'components/sales/modal/errorModal';
import parse from 'html-react-parser';
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import DivLayout from 'components/sales/divLayout/divLayout';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DatePicker from "components/sales/datePicker/datePicker";
import { handleValidateObj } from 'constants/objValues/objvalues';
import { toast } from 'react-toastify';
import TableSection from 'components/sales/tableSection/tableSection';

const TrainingChecklist = ({
  getDashboardTrainingChecklist,
  dashboardTraining,
  match,
  location,
  documentUploadUrl,
  postTrainingChecklistData,
  history,
}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [formData, setFormData] = useState(null);
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setIsErrorMsg] = useState('');
  const [pageCount, setPageCount] = useState(0);
  const [isErrorModal, setIsErrorModal] = useState(false);
  const [formField, setFormFields] = useState([]);
  const [completed, setCompleted] = useState('No');
  const [allCompleted,setAllCompleted] = useState('No');
  const [isTrainingComplete, setIsTrainingComplete] = useState('No');
  const [details, setDetails] = useState([]);
  const [addItem, setAddItem] = useState(1);
  const [leadType, setLeadType] = useState('');
  const [isTenant,setIsTenant] = useState('No');
  const [tData,setTData] = useState([]);
  const [listData, setListData] = useState();
  const tenants = [
    {tenant_name:'',tenant_email:'',tenantData:[{"key":"Overview tab briefed","checked":false},
    {"key":"Transactions tab briefed","checked":false},
    {"key":"Tags Inventory briefed","checked":false},
    {"key":"Hardware status briefed","checked":false},
    {"key":"How to raise ticket briefed","checked":false},
    {"key":"Dashboard access given ","checked":false},
    {"key":"Documents walk through","checked":false},
    {"key":"Parking data collected","checked":false}]}
  ];
  const [newTenants, setNewTenants] = useState(tenants);
  const [inputList, setInputList] = useState([
    {
    //   project_type: "",
      add_for: "",
      checklist_question: ""
    },
  ]);
  const [roles,setRoles] = useState([14,15,56]);
  const [roleId,setRoleId] = useState('');

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(true);
      (async () => {
        if(localStorage.getItem('roles')){
          const roles = await JSON.parse(localStorage.getItem('roles'))[0].id;
          setRoleId(roles);
        }
       
      })();
      setIsLoading(false);
    }, 1000);
  }, []);

  const handleInput2Value = (val, key, index) => {
    const list = [...inputList];
    // console.log(list);
    list[index][key] = val;
    setInputList([...list]);
  };

  const handleTenantValues = (val, key, index) => {
    const list = [...newTenants];
    // console.log(list);
    list[index][key] = val;
    setNewTenants([...list]);
  };

  const handleAddClick = () => {
    var size = Object.keys(inputList).length;
    setInputList([
      ...inputList,
      {
        // project_type: "",
        add_for: "",
        checklist_question: ""
      },
    ]);
  };

  const handleRemoveClick = (index) => {
    const list = [...inputList];
    list.splice(index, 1);
    setInputList(list);
  };

  const handleAddClickTenant = () => {
    var size = Object.keys(newTenants).length;
    setNewTenants([
      ...newTenants,
      {tenant_name:'',tenant_email:'',tenantData:[{"key":"Overview tab briefed","checked":false},
    {"key":"Transactions tab briefed","checked":false},
    {"key":"Tags Inventory briefed","checked":false},
    {"key":"Hardware status briefed","checked":false},
    {"key":"How to raise ticket briefed","checked":false},
    {"key":"Dashboard access given ","checked":false},
    {"key":"Documents walkthrough","checked":false},
    {"key":"Parking data collected","checked":false} ]},
    ]);
  };

  const handleRemoveClickTenant = (index) => {
    const list = [...newTenants];
    list.splice(index, 1);
    setNewTenants(list);
  };

  useEffect(() => {
    // console.log(dashboardTraining);
    setTData(dashboardTraining);
  },[dashboardTraining]);

  const handleCheckBox = (key,index) => {
   const list = [...formField];
   if(list[index]['checked']) {
    list[index]['checked'] = false;
   } else {
    list[index]['checked'] = true;
   }
   setFormFields([...list]);
  }

  const handleCheckBoxTenant = (key,pIndex,cIndex) => {
    const list = [...newTenants];
    // console.log(key + ' ' + pIndex + ' ' + cIndex + ' ' + JSON.stringify(list[pIndex]['tenantData'][cIndex]));
    if(list[pIndex]['tenantData'][cIndex]['checked']) {
      list[pIndex]['tenantData'][cIndex]['checked'] = false;
    } else {
      list[pIndex]['tenantData'][cIndex]['checked'] = true;
    }
    setNewTenants([...list]);
   }

  useEffect(() => {
    if (getDashboardTrainingChecklist !== null) (async () => await getDashboardTrainingChecklist(match?.params?.site_id))();
  }, [getDashboardTrainingChecklist]);

  const handleSubmit = async() => {
    let isNotEmpty = true;
    let isError = false;

    inputList.map((val)=> {
      if(!handleValidateObj(val)) {
        isNotEmpty = false;
        isError = true;
        return false;
      }
    });
    

    if(isError) {
      toast.error('Please fill mandatory details.');
      return false;
    } else {
          const payload = {
           data:inputList
          };
          //console.log('checklist_details ' + JSON.stringify(payload));
          //return false;
          setIsLoading(true);
          const res = await postTrainingChecklistData(payload);
          setIsLoading(false);
          if (res === true) { 
            setIsModal(true);
          }
          setIsLoading(false);
    }
  };

  // console.log("data" + JSON.stringify(newTenants));

  const handleModalHide = () => {
    setIsModal(false);
    window.location.reload();
  };
  const headerBtns = () => {
    return (
      <Fragment>
        <Button onClick={handleSubmit} className="btn btn-primary">
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button>
      </Fragment>
    );
  };
  const handleModalHide1 = () => setIsErrorModal(false);

  const headers = [
    'Question',
    'Label', 
    'Created On'
  ];

  useEffect(() => {
    const tableData = [
        'question_key',
        'question_label',
        'created_at'
    ];
    //console.log(incentives.data);
    if (tData && tData?.length > 0) {
        const data = tData.map((element) =>
            Object.assign(
                {},
                ...tableData.map((key) => ({[key]: element[key]}           
                    )
                ),
            )
        );  
        data && setListData(data);
        //setPageCount(Math.ceil(tData.total / tData.per_page));
    }
  }, [tData]);

  const onPageChange = async (val) => {
    
  };

  return (
    <Layout
      title={`Dashboard Training - Checklist`}
      Buttons={headerBtns}
      className={isFiled ? 'requiredFileds' : ''}
      isGoback
      linkFlag={true}
      isLoading={isLoading}
    >
      <div className="container-fluid">
        <div className="panel-card card-details">
          <div className="panel-heading">{localization.dashboardTrainingChecklist}</div>
          <div className="panel-body">
            {addItem === 1 ? (
                  <>
                    {inputList.map((x, i) => {
                      return (
                        <div className="row" key={{ i }}>
                        {/* <div className='col-md-6'>
                                <DropDownInput
                                    name="project_type"
                                    data={[
                                        { name: "Corporate", id: "1",},
                                        {name: "Appartment",id: "2",},
                                        {name: "Supply",id: "4",}
                                    ]}
                                    label={`Project Type`}
                                    required={true}
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    getIdValue={(val) => handleInput2Value(val.id, "project_type", i)}
                                />
                            </div> */}
                            <div className='col-md-4'>
                                <DropDownInput
                                    name="question_for"
                                    data={[
                                        {name: "Corporate", id: "Corporate"},
                                        {name: "Apartment",id: "Apartment"},
                                        {name: "Supply",id: "Supply"},
                                        {name: "Tenant",id: "Tenant"}
                                    ]}
                                    label={`Add checklist queston For`}
                                    required={true}
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    getIdValue={(val) => handleInput2Value(val.id, "add_for", i)}
                                />
                            </div>
                            <div className='col-md-8'>
                                <ConstantInput
                                    label={`Checklist Question`}
                                    type="text"
                                    required={true}
                                    isStarRequired={true}
                                    errorMsg={localization.isRequired}
                                    handleChange={(val) => {
                                        handleInput2Value(val, "checklist_question", i);
                                    }}
                                />
                            </div>
                            <div className="col-md-12 col-sm-12 d-flex">
                              {inputList.length !== 1 && (
                                <div className="col-md-2 col-sm-5">
                                  <button
                                    onClick={() => handleRemoveClick(i)}
                                    className="mr10 btn btn-sm btn-danger"
                                  >
                                    Remove
                                  </button>
                                </div>
                              )}
                              {inputList.length - 1 === i && (
                                <div className="col-md-2 col-sm-5">
                                  <button
                                    className="btn btn-sm btn-primary"
                                    onClick={handleAddClick}
                                  >
                                    Add
                                  </button>
                                </div>
                              )}
                            </div>

                          <div className='line2'></div>
                        </div>
                      );
                    })}
                  </>
                ) : addItem === 2 ? (
                  {}
                ) : null}
          </div>
        </div>
      </div>
      <div className="container-fluid">
      <div className="card mt-2">
        <div className="card-header">
          {'Checklist Questions'}
        </div>
        <div className="card-body">
        <TableSection
            data={listData}
            isId={false}
            isMngId={false}
            headers={headers}
            pageCount={pageCount}
            onPageChange={onPageChange}
            srNo={1}
        />
        </div>
      </div>  
      </div>
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.preB2bSuccess}</h5>
          <div className='d-inline-flex'><a className='btn btn-primary' onClick={() => window.location.reload()}>Back to list</a></div>
        </div>
      </ModalPop>
      <ErrModalPop
        title={localization.error}
        show={isErrorModal}
        handleModalHide={handleModalHide1}
        keyboard
        backdrop
      >
        <div className="text-center">
          {parse(errorMsg)}
        </div>
      </ErrModalPop>
    </Layout>
  );
};
export default TrainingChecklist;
